<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";   
import apigeneric from "@/helpers/apigeneric";
import Loader from "@/components/widgets/loader";
import Banner from "../components/banner";

export default {
  page: {
    title: process.env.VUE_APP_NAME,
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Loader,
    Banner

  },
  mixins: [ apigeneric],
  data() {
    return {
      title: this.$t('StrAnasayfa.Title'),
      DefaultPage: 1,
      Page: {
        PageNumber: 1,
        PageSize: 10,
        PageDataSize: 1,
      },
      NoticesData:{},
      NoticesTitle: {},
      NoticesTitleDescription: {},
      ReadMoreValue: {},
      LangId: this.$route.params.LangId,
      items: [
         
        {
          text: this.$t('StrAnasayfa.Title'),
          active: true,
        },
      ],  
      fetchingStats: true,  
    };
  }, 
  methods: { 
    getFirstImage(gallery) {
      if (gallery && typeof gallery === 'string' && gallery.trim() !== '') {
        return gallery.split(',')[0].trim();
      }
      return '';
    },
    handleImgError(e) {
      e.target.style.display = 'none';
      if (e.target.parentElement) {
        const fallback = e.target.parentElement.querySelector('.img-fallback-icon');
        if (fallback) fallback.style.display = 'flex';
      }
    },
    Get(){
        
      if(this.LangId=="tr" || this.LangId== null){
        this.ActionsFilterGet({
        Service: "News",
        Page: this.Page,
        Filter:
       "&Newstype=1&Websiteid="+window.$cookies.get("ecampuswebsite"),
      }).then((res) => {
        this.NoticesData = res.Data; 
          this.Page.PageDataSize = res.TotalCount;
      });
    }else{
      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
       "&shortlangtitle="+this.LangId
      }).then((res) => {
        for( let LangData in res.Data){
          this.ActionsFilterGet({
        Service: "newstranslations",
        Page: this.Page,
        Filter: "&Langid="+ res.Data[LangData].Id
      }).then((res) => {
        this.NoticesData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        if(res.TotalCount == 0){
              localStorage.setItem("lang", "tr");
              window.location.reload();
              
            }
        
      });
         }
        
      });
     
    }
    this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.LangId
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=215b4e3e-250f-4ebd-bf96-f04aec90de20"
          }).then((res) => {
            this.NoticesTitle = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });

      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.LangId
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=19269e1f-b2fe-4ea9-9a2b-4c5cd91d2266"
          }).then((res) => {
            this.NoticesTitleDescription = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });

      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.LangId
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=878b315b-fa05-41b1-9cc5-4c480effbf65"
          }).then((res) => {
            this.ReadMoreValue = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });
    }
  },
};
</script>

<template>
 <Loader>
  <Layout> 
      <Banner />
     
<section>
        <div class="notices">
            <div class="title c-flex flex-column">
                <h3>{{NoticesTitle[0].Resourcevalue}}</h3>
                <p>{{NoticesTitleDescription[0].Resourcevalue}}</p>
            </div> 
            <div class="container">
                <div class="row align-items-stretch">
                   
                        <div class="col-md-6 mb-4 d-flex align-items-stretch"  v-for="Data in NoticesData" :key="Data.Id">
                          <div class="notice-item w-100 h-100 d-flex flex-column">
                            <div class="row h-100 g-0">
                                <div class="col-md-5 d-flex align-items-stretch">
                                    <div class="notice-img-box w-100 h-100">
                                        <img v-if="getFirstImage(Data.Imagegallery)" :src="$config.FILES_URL + 'web/' + getFirstImage(Data.Imagegallery)" alt="" @error="handleImgError" />
                                        <div class="img-fallback-icon h-100" :style="{ display: getFirstImage(Data.Imagegallery) ? 'none' : 'flex' }">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#ffffff" opacity="0.85" viewBox="0 0 16 16">
                                                <path d="M0 2.5A1.5 1.5 0 0 1 1.5 1h11A1.5 1.5 0 0 1 14 2.5v10.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 13V2.5zM1.5 2a.5.5 0 0 0-.5.5v10.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V2.5a.5.5 0 0 0-.5-.5h-11z"/>
                                                <path d="M3 4h8v1H3V4zm0 3h8v1H3V7zm0 3h5v1H3v-1z"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-7 d-flex justify-content-between flex-column h-100">
                                    <div>
                                        <p class="head">{{Data.Title}}</p>
                                        <p class="date">{{Data.Startdate | formatDateTime }}</p>
                                        <p class="content">
                                             <span v-html="Data.Description"></span><br />
                                        </p>
                                    </div>
                                    <a :href="'/NewsDetail/'+ LangId + '/' + Data.Title.toLowerCase()
                                    .replace(/I|İ/gi, 'i')
                                    .replace(/Ğ|ğ/gi, 'g')
                                    .replace(/Ç|ç|ğ/gi, 'c')
                                    .replace(/\s+/g, '-')
                                    .replace(/&/g, `-and-`)
                                    .replace(/--/g, `-`) + '/'
                 + Data.Id" class="read-more mt-auto">{{ReadMoreValue[0].Resourcevalue}} &#8594;</a>
                                </div>
                            </div>
                          </div>
                    </div>                  
                </div>
            </div>
                    <b-pagination
                class="pagination pagination-rounded justify-content-end mb-2"
                v-model="DefaultPage"
                :total-rows="Page.PageDataSize"
                :per-page="Page.PageSize"
                aria-controls="my-table"
                @input="ChangePage(DefaultPage)"
              >
              </b-pagination>
        </div>
    </section>



     
  
  </Layout>
  </Loader>
</template>

<style scoped>
.notice-item {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.notice-img-box {
  width: 100%;
  height: 100%;
  min-height: 180px;
  background-color: #00758f;
  border-radius: 40px 40px 0 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (min-width: 768px) {
  .notice-img-box {
    border-radius: 40px 0 0 40px;
  }
}
.notice-img-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #00758f;
}
.img-fallback-icon {
  width: 100%;
  height: 100%;
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00758f;
}
</style>
